import {
    defineStore,
} from 'pinia';

const changeCallbacks = [];

export const useLoadingStore = defineStore('loading', {
    state: () => ({
        progressBar: false,
        initialLoadingOverlay: true,
    }),
    actions: {
        startProgressBar() {
            this.progressBar = true;
            this.callChangeCallbacks();
        },
        finishProgressBar() {
            this.progressBar = false;
            this.callChangeCallbacks();
        },
        registerChangeCallback(cbk) {
            if (!changeCallbacks.includes(cbk)) {
                changeCallbacks.push(cbk);
            }
        },
        callChangeCallbacks() {
            for (const cbk of changeCallbacks) {
                cbk(this.progressBar);
            }
        },
    },
});
